
export default function ProcessSection() {
  const steps = [
    {
      number: "1",
      title: "Candidature",
      description: "Remplissez notre formulaire de candidature avec vos informations et expérience."
    },
    {
      number: "2",
      title: "Évaluation",
      description: "Notre équipe examine votre profil et vos certifications sous 48h."
    },
    {
      number: "3",
      title: "Entretien",
      description: "Entretien vidéo avec notre équipe pour valider votre approche coaching."
    },
    {
      number: "4",
      title: "Formation",
      description: "Formation d'intégration sur notre plateforme et nos outils."
    },
    {
      number: "5",
      title: "Lancement",
      description: "Création de votre profil et début de votre activité sur la plateforme."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Processus de Sélection
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Un processus simple et transparent en 5 étapes pour rejoindre notre équipe
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-lg font-bold">
                {step.number}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-gray-600 text-sm">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-1/2 w-full h-0.5 bg-gray-300 transform translate-x-1/2"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
